import React from 'react';
import { CitizensBandRadio } from '.';
import SignImageContent from './SignImageContent';

export default function DisplayContent( props ){
    const {signType, ID, contentID} = props 
    //console.log(signType, ID, contentID)
    if (signType ==='CitizensBandRadio'){
        return <CitizensBandRadio ID ={ID} textID={contentID}/>
    }else {
        // console.log("contentID",contentID)
        return <SignImageContent signID = {ID} imageID={contentID}/>
    }   
}